import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserService } from '@app/core/services/user.service';
import { UserType } from '@app/core/utils/user-type';
import { DictionaryGuard } from '@app/pcs/guards/dictionary-guard';
import { UserTypeGuard } from '@app/pcs/guards/user-type-guard';
import { ValdrConstraintsGuard } from '@app/pcs/guards/valdr-constraints.guard';
import { PcsComponent } from '@app/pcs/pcs.component';
import { TIMETABLE_PERIODS_PATH } from '@app/pcs/timetable-periods/utils/timetable-periods-util';
import { isNotNil } from '@util';

const routes: Routes = [
  {
    path: 'app',
    component: PcsComponent,
    canActivate: [
      // check if user is logged in
      () => isNotNil(inject(UserService).user),
      DictionaryGuard,
      ValdrConstraintsGuard
    ],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module')
      },
      {
        path: 'dossier',
        loadChildren: () => import('./dossier/dossier.module')
      },
      {
        path: 'pap-import',
        loadChildren: () => import('./pap-import/pap-import.module'),
        canLoad: [UserTypeGuard],
        data: {
          allowedUserTypes: [UserType.COSS, UserType.IM]
        }
      },
      {
        path: 'pap/search',
        loadChildren: () => import('./pap-search/pap-search.module')
      },
      {
        path: 'rfc-kpi-reports',
        loadChildren: () => import('./rfc-kpi-reports/rfc-kpi-reports.module'),
        canLoad: [UserTypeGuard],
        data: {
          allowedUserTypes: [UserType.COSS, UserType.ADMIN]
        }
      },
      {
        path: 'administration',
        loadChildren: () => import('./administration/administration.module')
      },
      {
        path: 'user',
        loadChildren: () => import('./user/user.module')
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module')
      },
      {
        path: 'bulk',
        loadChildren: () => import('./bulk/bulk.module')
      },
      {
        path: 'reporting',
        loadChildren: () => import('./reporting/reports.module')
      },
      {
        path: 'agencies-and-users',
        loadChildren: () => import('./agencies-and-users/agencies-and-users.module')
      },
      {
        path: 'pamt-search',
        loadChildren: () => import('./pamt-search/pamt-search.module')
      },
      {
        path: 'promotions/:ttpId',
        loadChildren: () => import('./promotion/promotions.module')
      },
      {
        path: 'web-services',
        loadChildren: () => import('./web-services-admin/web-services-admin.module')
      },
      {
        path: TIMETABLE_PERIODS_PATH,
        loadChildren: () => import('./timetable-periods/timetable-periods.module')
      },
      {
        path: 'distance-editor',
        loadChildren: () => import('./distance-editor/distance-editor.module')
      },
      {
        path: 'features',
        loadChildren: () => import('./features/features.module')
      },
      {
        path: 'border-harmonization-search',
        loadChildren: () => import('./border-harmonization-search/border-harmonization-search.module'),
        canLoad: [UserTypeGuard],
        data: {
          allowedUserTypes: [UserType.ADMIN, UserType.RNEJO]
        }
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class PcsRoutingModule {
  static components = [
    PcsComponent
  ];
}
